<template>
    <u-select-solo-rounded v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-solo-rounded>
</template>

<script>
import USelectSoloRounded from "@/components/publish/styles/forms/u-select-solo-rounded.vue";

export default {
    props: {},
    components: {
        USelectSoloRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
